// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/styles/specific/static/Tabs.css
// module id = 833
// module chunks = 1